import React from 'react';
import styled, { StylesProps, cx } from '../../../lib/styles';
import { Article } from '../../../models/article';

import lightStoryStyles from './LightStory_styles';
import dayjs from 'dayjs';

export interface LightStoryProps {
  slot?: string;
  vane?: boolean;
  article: Article;
  onClick?: () => any;
  renderAttribution?: boolean;
}

const LightStory = ({
  slot,
  onClick,
  article: { title, author, category, category_link, link, created },
  renderAttribution = true,
  styles,
}: LightStoryProps & StylesProps<typeof lightStoryStyles>) => (
  <div className={cx('LightStory', styles.container)}>
    <a href={category_link} className={styles.category}>
      {category}
    </a>

    <div id={slot} data-parsely-slot={slot}>
      <a href={link} title={title} className={styles.link} onClick={onClick}>
        <div className={styles.contentBlock}>
          <h2 className={cx(styles.title, 'Story__title')}>{title}</h2>
          {renderAttribution && 
            <h3 className={styles.byline}>
              <span className={styles.bylineAuthor}>
                {dayjs(created).format('MMMM DD, YYYY')} - {author.name}
              </span>
            </h3>
          }
        </div>
      </a>
    </div>
  </div>
);

export default styled(lightStoryStyles)(LightStory);
